import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { ICarValuationState } from "./types";

export type CarValuationPayload = {
  phone: string;
  carNumber: string;
};

const initialState: ICarValuationState = {
  carValuation: {},
};

const slice = createSlice({
  name: "CarValuation",
  initialState,
  reducers: {
    carValuation(state) {
      state.carValuation.status = RequestStatus.RUNNING;
    },

    carValuationSuccess(state, action) {
      state.carValuation.status = RequestStatus.SUCCESS;
      state.carValuation.data = action.payload?.data;
      state.carValuation.message = action.payload?.message;
    },

    carValuationFailed(state, action: PayloadAction<any>) {
      state.carValuation.status = RequestStatus.ERROR;
      state.carValuation.error = action.payload;
      state.carValuation.message = action.payload?.message;
    },
    resetCarValuation(state) {
      state.carValuation = {};
    },
  },
});

export default slice.reducer;
export const {
  carValuation,
  carValuationFailed,
  carValuationSuccess,
  resetCarValuation,
} = slice.actions;
